import get from 'lodash/get';

export default function trackjs(currentState) {
  if (get(currentState, 'config.env') === 'development') {
    return '';
  }

  return `<!-- BEGIN TRACKJS -->
<script type="text/javascript">window._trackJs = { token: '273b729e2fa84da381a6ddafecd71c58' };</script>
<script async type="text/javascript" src="https://cdn.trackjs.com/releases/current/tracker.js"></script>
<!-- END TRACKJS -->`;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/trackjs.js